import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from '../../../orders/models';
import { PotentialAction } from '../../models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { Actions, ofType } from '@ngrx/effects';
import { filter, takeUntil } from 'rxjs/operators';
import { DataRecoveryCostsActions } from '../../../orders/store';
import { DataRecoveryCostsSelectors } from '../../../orders/store/selectors';
import { TransitionsActions } from '../../../application-state/store/actions';
import { BaseOnDestroyComponent } from '../../injectables/BaseOnDestroy.component';
import { ActionBoxInputTypes } from '../../models/action-box-input-types.type';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-action-box-to-analysis-purchase-prices',
  styleUrls: ['./action-box-to-analysis-purchase-prices.component.scss'],
  template: `
    <div class="action-box">
      <div class="action-required-label" *ngIf="canMakeTransition">
        Aktion erforderlich
      </div>
      <div class="action-required-label bg-green" *ngIf="!canMakeTransition">
        Warte auf Zuarbeit
      </div>
      <div class="content ">
        <div class="row" *ngIf="canMakeTransition">
          <div class=" col-auto my-2 align-items-center">
            <div class="row ">
              <div class=" col-auto header">Kosten definieren</div>
              <div class="sub-header col-auto">
                Bitte definieren Sie die Kosten
              </div>
            </div>
          </div>
          <div class="actions col my-2 text-right"></div>
        </div>
        <div class="row " *ngIf="!canMakeTransition">
          <div class=" col-auto header">Warte auf EK Preis</div>
          <div class="sub-header col-auto">
            Warte auf Definierung der EK Preise
          </div>
        </div>
      </div>
      <div
        class="additional-content p-2"
        [formGroup]="form"
        *ngIf="canMakeTransition"
      >
        <div class="row">
          <div class="col-lg-5">
            <div class="d-flex align-items-center">
              <div class=" mx-1" style="width:50%;">
                <h4 class="mb-1">Berechneter Preis Datenrettung</h4>
                <mat-form-field
                  formGroupName="calculatedPurchasePriceDataRecovery"
                >
                  <mat-label>Preis in €</mat-label>
                  <input
                    formControlName="value"
                    type="text"
                    readonly
                    matInput
                    currencyMask
                    [options]="{ prefix: '' }"
                  />
                </mat-form-field>
              </div>
              <div class=" mx-1" style="width:50%;">
                <h4 class="mb-1">Preis Datenrettung</h4>
                <mat-form-field formGroupName="purchasePriceDataRecovery">
                  <mat-label>Preis in €</mat-label>
                  <input
                    formControlName="value"
                    type="text"
                    matInput
                    required
                    currencyMask
                    [options]="{ prefix: '' }"
                  />
                  <mat-error>
                    <app-form-error
                      [fieldName]="'purchasePriceDataRecovery.value'"
                      [formGroup]="form"
                    ></app-form-error>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="mx-1" style="width:50%;">
                <h4 class="mb-1">Berechneter Preis Sonstiges</h4>
                <mat-form-field formGroupName="calculatedPurchasePriceOther">
                  <mat-label>Preis in €</mat-label>
                  <input
                    formControlName="value"
                    type="text"
                    readonly
                    matInput
                    currencyMask
                    [options]="{ prefix: '' }"
                  />
                </mat-form-field>
              </div>
              <div class="mx-1" style="width:50%;">
                <h4 class="mb-1">Preis Sonstiges</h4>
                <mat-form-field formGroupName="purchasePriceOther">
                  <mat-label>Preis in €</mat-label>
                  <input
                    formControlName="value"
                    type="text"
                    matInput
                    required
                    currencyMask
                    [options]="{ prefix: '' }"
                  />
                  <mat-error>
                    <app-form-error
                      [fieldName]="'purchasePriceOther.value'"
                      [formGroup]="form"
                    ></app-form-error>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <mat-form-field>
              <mat-label>Kommentar</mat-label>
              <textarea
                matInput
                formControlName="purchasePriceComment"
                rows="10"
                cdkTextareaAutosize
              ></textarea>
              <mat-error>
                <app-form-error
                  [fieldName]="'purchasePriceComment'"
                  [formGroup]="form"
                ></app-form-error>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <div class="col text-right">
              <button
                class="decision-btn me-3"
                mat-button
                color="green"
                (click)="submitForm()"
                [disabled]="form.invalid || !okAction"
              >
                <mat-icon class="me-2">done</mat-icon>
                <span>Preise definieren/bestätigen</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class ActionBoxToAnalysisPurchasePricesComponent
  extends BaseOnDestroyComponent
  implements OnInit {
  @Input() order$: Observable<Order>;
  @Input() inputType: ActionBoxInputTypes;

  order: Order;
  okAction: PotentialAction = null;
  form: FormGroup;

  constructor(
    private store$: Store<ApplicationState>,
    private fb: FormBuilder,
    private authService: AuthService,
    private actions$: Actions
  ) {
    super();
  }

  get canMakeTransition(): boolean {
    return (
      (this.inputType === 'ticket' && this.authService.isAdmin()) ||
      (this.okAction?.transition?.indexOf('dr_remote') > -1 &&
        this.authService.isTechnicianExternal()) ||
      (this.okAction?.transition?.indexOf('dr_ext') > -1 &&
        this.authService.isTechnicianExternal()) ||
      false
    );
  }

  ngOnInit(): void {
    this.initForm();
    this.order$
      .pipe(
        takeUntil(this.onDestroy$),
        filter(order => !!order)
      )
      .subscribe(order => {
        this.order = order;
        if (order.dataRecoveryCosts) {
          const lastDataRecoveryCosts =
            order.dataRecoveryCosts[order.dataRecoveryCosts.length - 1];
          this.store$.dispatch(
            DataRecoveryCostsActions.ReadDataRecoveryCosts({
              iri: lastDataRecoveryCosts
            })
          );
          this.store$
            .select(DataRecoveryCostsSelectors.sByIri, {
              iri: lastDataRecoveryCosts
            })
            .pipe(
              takeUntil(this.onDestroy$),
              filter(DRCosts => !!DRCosts)
            )
            .subscribe(costs => {
              this.form.patchValue(costs);
            });
        }
        this.okAction = order.potentialActions?.find(
          e =>
            e.transition.indexOf('to_analysis_purchase_prices_provided') > -1 &&
            !e.error
        );
      });
  }

  initForm(): void {
    this.form = this.fb.group({
      purchasePriceDataRecovery: this.fb.group({
        value: this.fb.control(null, [Validators.required]),
        currency: this.fb.control('EUR', [Validators.required])
      }),
      purchasePriceOther: this.fb.group({
        value: this.fb.control(null, [Validators.required]),
        currency: this.fb.control('EUR', [Validators.required])
      }),
      calculatedPurchasePriceDataRecovery: this.fb.group({
        value: this.fb.control(110000001),
        currency: this.fb.control('EUR', [Validators.required])
      }),
      calculatedPurchasePriceOther: this.fb.group({
        value: this.fb.control(1548722),
        currency: this.fb.control('EUR', [Validators.required])
      }),
      purchasePriceComment: this.fb.control('')
    });
  }

  makeTransition(): void {
    const action = this.okAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }

  submitForm(): void {
    const lastDRCostsIri = this.order.dataRecoveryCosts[
      this.order.dataRecoveryCosts.length - 1
    ];
    const values = this.form.getRawValue();
    const payload: any = { ['@id']: lastDRCostsIri, ...values };
    payload.purchasePriceDataRecovery.value =
      payload.purchasePriceDataRecovery.value.toString() || '0.0';
    payload.purchasePriceOther.value =
      payload.purchasePriceOther.value.toString() || '0.0';
    console.log(payload);
    this.store$.dispatch(
      DataRecoveryCostsActions.UpdatePurchasePrices({
        iri: lastDRCostsIri,
        payload
      })
    );
    this.actions$
      .pipe(
        ofType(DataRecoveryCostsActions.UpdatePurchasePricesSuccess),
        takeUntil(this.onDestroy$)
      )
      .subscribe(() => {
        this.makeTransition();
      });
  }
}
